import React, { useCallback, useEffect, useRef, useState } from "react";
import { Spin, Select, Checkbox, Form, Input, Button, Table, Modal, message, notification } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { getGenderCategory, getGenderCategoryChange } from "../../redux/actions/genderCategory.action";
import { getProductStatus } from "../../redux/actions/productStatus.actions";
import { getGender } from "../../redux/actions/gender.action";
import { getSku } from "../../redux/actions/sku.action"
import { ReadCookie } from "../../utils/readCookie";
import { getStyle, getStyleChange, getStyleChangeNew } from "../../redux/actions/style";
import btnPrint from "../../assets/images/button_print.gif";
import xlsx from "../../assets/images/ico_xls_sm.gif";
import logo from "../../assets/images/logo-black.svg";
import pdf from "../../assets/images/PDF_file_icon.svg.png";
import "../Distributor/Distributor.css";
import { useHistory } from "react-router-dom";
import { TabTitle } from "../../utils/GeneralFunction";
import { CSVLink } from "react-csv";
import numeral from "numeral";
import { generateDynamicPDF } from "../../utils/generateDynamicPDF";
import { getFitCategory, getFitChange } from "../../redux/actions/fitCategory.action";
import { getAmazonProductInformation, getAmazonProductUploader, getAmazonProductUploaderDetailsPants, getAmazonViewProduct } from "../../redux/actions/amazonProductInformation.action";
import Loader from "react-spinners/BarLoader";
import { getProductType } from "../../redux/actions/productType.action";
import { getSeason } from "../../redux/actions/season.action";
import { getProductClass } from "../../redux/actions/productClass.action";
import { getSize } from "../../redux/actions/size.action";
import { getWashChange, getWashName } from "../../redux/actions/wash.action";
import { getSeasonYear } from "../../redux/actions/seasonYear.action";
import { getFabric } from "../../redux/actions/fabric.action";
import { Axios } from "axios";
import { Row, Col, Divider, Tag, Image } from "antd";
import "./amazonProductUploader.css"

const AmazonProductUploader = ({ token }) => {
  TabTitle("Amazon-pr")
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const {
    productStatus,
    gender,
    style,
    styleChange,
    wash,
    washChange,
    fitCategory,
    fitChange,
    amazonProductUploader
  } = useSelector((state) => state);
  const history = useHistory();
  const menuId = ReadCookie("menuId");
  const userName = ReadCookie("name");
  const tableRef = useRef(null);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([])
  const [excelData, setExcelData] = useState([])
  const [selectedStatuses, setSelectedStatuses] = useState([3]);
  const [allSelected, setAllSelected] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  const [buttonLoading, setButtonLoading] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const { Option } = Select;



  const handleAllChange = (e) => {
    if (e.target.checked) {
      setAllSelected(true);
      setSelectedStatuses([]);
    }
  };

  const handleStatusChange = (id, checked) => {
    let updated = [...selectedStatuses];

    if (checked) {
      updated.push(id);
    } else {
      updated = updated.filter(item => item !== id);
    }
    setSelectedStatuses(updated);

    if (updated.length === 0) {
      setAllSelected(true);
    } else {
      setAllSelected(false);
    }
  };



  const onFinish = async (e) => {
    setLoading(true)
    setSelectedRows([])
    await form.validateFields().then((values) => {
      const formData = {
        ...values,
        product_status: allSelected ? null : selectedStatuses.join(","),
      }
      dispatch(getAmazonProductUploader(token, formData)).then((res => {
        setLoading(false)
        setData(res?.payload?.data)
        downloadExcelFileData(res?.payload?.data);
      }));
    });
  };


  // const handleViewClick = (record) => {
  //   console.log("record", record.parent_item_code)
  //   setIsViewModalOpen(true);
  //   setViewLoading(true);

  //   dispatch(getAmazonViewProduct(token, record.parent_item_code, record.inseam)).then((res) => {
  //     setViewLoading(false);
  //     setTableData(res?.payload?.data || []);
  //   });
  // };

  const rowSelection = {
    onChange: (selectedRowKeys, selectedRows) => {
      setSelectedRows(selectedRows);
    },
  };


  function downloadExcelFileData(data) {
    if (data?.length > 0) {
      setExcelData(
        data.map((v) => {
          return {
            "Gender": v.gender_name,
            "Gender Category": v.gender_category_name,
            "Product Type": v.product_type_name,
            "Fit Category": v.fit_category_name,
            "Style": v.style_name,
            "Wash": v.wash_name,
            "Fabric": v.fabric_name,
            "Rise": v.rise_label_name,
            "Current Season": v.newseason_name,
            "Current Season Year": v.season_year,
            "SKU": v.item_code,
            "Inseam": v.inseam,
            "Bergen": v.bergan,
          };
        })
      )
    }
  }


  useEffect(() => {
    dispatch(getStyle(token, menuId));
    dispatch(getProductType(token));
    dispatch(getGenderCategory(token, menuId));
    dispatch(getProductStatus(token, menuId));
    dispatch(getSize(token, menuId));
    dispatch(getGender(token, menuId));
    dispatch(getFitCategory(token, menuId));
    dispatch(getWashName(token, menuId));
  }, [dispatch, menuId, token]);



  const handlePrint = () => {
    const css = '@page { margin-top: 8px; margin-bottom: 8px;  size: landscape;  }';
    const style = document.createElement('style');
    style.innerHTML = css;
    document.head.appendChild(style);
    window.print();
    document.head.removeChild(style);
  };


  const columns = [
    {
      title: "S#",
      align: "center",
      width: "60px",
      sorter: (a, b) => 0,
      render: (text, record, index) => {
        return index + 1
      },
    },
    {
      title: "Gender",
      dataIndex: "gender_name",
      key: "gender_name",
      sorter: (a, b) => {
        if ((a.gender_name !== null) & (b.gender_name !== null)) {
          return a.gender_name.localeCompare(b.gender_name);
        }
      },
    },
    {
      title: "Gender Category",
      dataIndex: "gender_category_name",
      key: "gender_category_name",
      sorter: (a, b) => {
        if ((a.gender_category_name !== null) & (b.gender_category_name !== null)) {
          return a.gender_category_name.localeCompare(b.gender_category_name);
        }
      },
    },
    {
      title: "Product Type",
      dataIndex: "product_type_name",
      key: "product_type_name",
      sorter: (a, b) => {
        if ((a.product_type_name !== null) & (b.product_type_name !== null)) {
          return a.product_type_name.localeCompare(b.product_type_name);
        }
      },
    },
    {
      title: "Fit Category",
      dataIndex: "fit_category_name",
      key: "fit_category_name",
      sorter: (a, b) => {
        if ((a.fit_category_name !== null) & (b.fit_category_name !== null)) {
          return a.fit_category_name.localeCompare(b.fit_category_name);
        }
      },
    },
    {
      title: "Style",
      dataIndex: "style_name",
      key: "style_name",
      sorter: (a, b) => {
        if ((a.style_name !== null) & (b.style_name !== null)) {
          return a.style_name.localeCompare(b.style_name);
        }
      },
    },
    {
      title: "Wash",
      dataIndex: "wash_name",
      key: "wash_name",
      sorter: (a, b) => {
        if ((a.wash_name !== null) & (b.wash_name !== null)) {
          return a.wash_name.localeCompare(b.wash_name);
        }
      },
    },

    {
      title: "Fabric",
      dataIndex: "fabric_name",
      key: "fabric_name",
      sorter: (a, b) => {
        if ((a.fabric_name !== null) & (b.fabric_name !== null)) {
          return a.fabric_name.localeCompare(b.fabric_name);
        }
      },
    },
    {
      title: "Rise",
      dataIndex: "rise_label_name",
      key: "rise_label_name",
      sorter: (a, b) => {
        if ((a.rise_label_name !== null) & (b.rise_label_name !== null)) {
          return a.rise_label_name.localeCompare(b.rise_label_name);
        }
      },
    },
    {
      title: "C. Season",
      dataIndex: "newseason_name",
      key: "newseason_name",
      sorter: (a, b) => {
        if ((a.newseason_name !== null) & (b.newseason_name !== null)) {
          return a.newseason_name.localeCompare(b.newseason_name);
        }
      },
    },
    {
      title: "C. Season Year",
      dataIndex: "season_year",
      key: "season_year",
      sorter: (a, b) => {
        if ((a.season_year !== null) & (b.season_year !== null)) {
          return a.season_year.localeCompare(b.season_year);
        }
      },
    },
    {
      title: "SKU",
      dataIndex: "item_code",
      key: "item_code",
      sorter: (a, b) => {
        if ((a.item_code !== null) & (b.item_code !== null)) {
          return a.item_code.localeCompare(b.item_code);
        }
      },
    },
    {
      title: "Inseam",
      dataIndex: "inseam",
      key: "inseam",
      sorter: (a, b) => {
        if ((a.inseam !== null) & (b.inseam !== null)) {
          return a.inseam.localeCompare(b.inseam);
        }
      },
    },
    {
      title: "Bergen",
      dataIndex: "bergan",
      key: "bergan",
      align: "right",
      sorter: (a, b) => {
        if ((a.bergan !== null) & (b.bergan !== null)) {
          return a.bergan - b.bergan;
        }
      },
    },
  ];

  // function debounce(cb, delay = 1000) {
  //   let timeout
  //   return (...args) => {
  //     clearTimeout(timeout)
  //     timeout = setTimeout(() => {
  //       cb(...args)
  //     }, delay)
  //   }
  // }


  // const handleSkuSearch = () => {
  //   dispatch(getSku(token, null, null, null));
  // }

  // const optimizedFn = useCallback(debounce(handleSkuSearch), []);


  const handleButtonClick = () => {
    setIsModalVisible(true);
  };

  const handleConfirm = () => {
    setIsModalVisible(false);
    setButtonLoading(true);

    const parentItemID = selectedRows
      .map(row => row?.item_id)
      .filter(Boolean);

    console.log("parentItemID", parentItemID);

    dispatch(getAmazonProductUploaderDetailsPants(token, parentItemID))
      .then((response) => {
        if (response?.payload) {
          const excelBlob = new Blob(
            [response.payload],
            {
              type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            }
          );

          const excelUrl = window.URL.createObjectURL(excelBlob);
          const link = document.createElement("a");
          link.href = excelUrl;
          link.download = "Amazon_Product.xlsx";
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          window.URL.revokeObjectURL(excelUrl);
        }

        notification.success({
          message: "Success",
          description: "Excel downloaded successfully!",
        });

        setSelectedRows([]);
        onFinish();
      })
      .catch((error) => {
        console.error("API call error:", error);

        notification.error({
          message: "Error",
          description: "Something went wrong while downloading Excel!",
        });
      })
      .finally(() => {
        setButtonLoading(false);
      });
  };



  const handleCancel = () => {
    setIsModalVisible(false);
  };


  const handleGender = (gender_id) => {
    dispatch(getFitChange(token, gender_id, null));
    dispatch(getStyleChangeNew(token, gender_id, null));
    dispatch(getWashChange(token, gender_id, null, null));
    form.setFieldsValue({
      style_id: "All",
      wash_id: "All",
      fit_id: "All"
    })
  }

  const handleStyle = (fit_category_id) => {
    dispatch(getStyleChangeNew(token, form.getFieldValue().gender_id, fit_category_id))
    dispatch(getWashChange(token, form.getFieldValue().gender_id, fit_category_id, null));
    form.setFieldsValue({
      style_id: "All",
      wash_id: "All",
    })
  }

  const handleWash = (style_id) => {
    dispatch(getWashChange(token, form.getFieldValue().gender_id, form.getFieldValue().fit_id, style_id));
    form.setFieldsValue({
      wash_id: "All",
    })
  }


  return (
    <div className="header_class business_header_oms print-container">
      <div className="row justify-content-between business_class_oms distributor distributor_amazon">
        <div className="col-3 d-flex align-items-start box-space">
          {/* <div className="logobrand">
            <img id="ImgLogo" alt="logo" src={logo} />
          </div> */}
        </div>
        {/* <div className="col-sm-6 box-space pl-sm-0">
                    <div className="brand-para">
                        <div>DL1961 Premium Denim Inc.</div>
                        <div>121 Varick Street</div>
                        <div>4th Floor</div>
                        <div>New York, NY 10013</div>
                        <div>(P) 646-514-9736</div>
                        <div>(F) 212-991-9989</div>
                        <div>(E) sales@DL1961.com</div>
                    </div>
                </div> */}
        <div className="col-4 box-space right-content-header text-right">
          <div className=" d-flex justify-content-end">
            <div className=" d-flex justify-content-end mr-8 printing_class">
              <div className="print_icon printing_class">
                <i
                  onClick={handlePrint}
                  id="Image1"
                  title="Print"
                  alt="Print"
                  src={btnPrint}
                  className="fa-solid fa-print"
                ></i>
              </div>
              <div className="print_icon printing_class">
                <CSVLink
                  filename={"amazon-product.csv"}
                  data={excelData}
                  style={{ display: "flex" }}
                  onClick={() => {
                  }}
                >
                  <input
                    type="image"
                    name="ImgExcel"
                    alt="Export to excel"
                    id="ImgExcel"
                    title="Export to excel"
                    src={xlsx}
                    style={{ borderWidth: "0px", height: "14px" }}
                  // onClick={handleExcelExport}
                  />
                </CSVLink>
              </div>
            </div>
            <span style={{ fontSize: "small", fontWeight: "bolder" }}>
              Amazon Product
              <br />
              {/* Rpt # 489
              <br />
              <p className=" mb-0">Rpt # 001_V4</p> */}
              Login as:{" "}
              <span id="lblSalesPerson" style={{ fontWeight: "bold" }}>
                {userName}
              </span>
              {/* <br /> */}
            </span>
          </div>
        </div>
      </div>
      <div className="business_class_oms mb-2 distributor distributor_amazon">
        <Form form={form} name="control-hooks" onFinish={onFinish}>
          <div className="main_form row">
            <div className="col-12">
              <hr className="my-2" />
              <div>
                <label htmlFor="">Product Status</label>
                <div className="checkboxes">
                  <div className="checkbox_content">
                    <Form.Item name="current_status_id" className=" mb-0">
                      <Checkbox checked={allSelected} onChange={handleAllChange} className="amazon-product-uploader-checkbox">
                        All
                      </Checkbox>
                    </Form.Item>
                  </div>
                  {productStatus &&
                    productStatus?.payload?.data.map((it, index) => {
                      return (
                        <div key={index} className="checkbox_content">
                          <Form.Item name="current_status_id">
                            <Checkbox
                              className="amazon-product-uploader-checkbox"
                              key={it.product_status_id}
                              checked={selectedStatuses.includes(it.product_status_id)}
                              onChange={(e) =>
                                handleStatusChange(it.product_status_id, e.target.checked)
                              }
                            >
                              {it.product_status_name}
                            </Checkbox>
                          </Form.Item>
                        </div>
                      );
                    })}
                </div>
              </div>
              <hr className="my-2 mb-3" />
              <div className="main_form row">
                <div className="col-12 col-xl-3 col-md-4 mb-2">
                  <div className=" d-flex flex-column align-items-baseline amazon-product-uploader-input">
                    <label className="labels width44" htmlFor="">Gender</label>
                    <div className="w-100 fit-selectbox-width">
                      <Form.Item name="gender_id" initialValue={"All"}>
                        <Select
                          className={"select_Inputs"}
                          showSearch
                          optionFilterProp="children"
                          size="small"
                          onChange={(e) => handleGender(e)}
                        >
                          <Option value="All">All</Option>
                          {gender &&
                            gender?.payload?.data.map((it, index) => {
                              return (
                                <Option key={index} value={it.gender_id}>
                                  {it.gender_name}
                                </Option>
                              );
                            })}
                        </Select>
                      </Form.Item>
                    </div>
                  </div>
                </div>
                <div className="col-12 col-xl-3 col-md-4 mb-2">
                  <div className=" d-flex flex-column align-items-baseline amazon-product-uploader-input">
                    <label className="labels width44" htmlFor="">Fit Category</label>
                    <div className="w-100 fit-selectbox-width">
                      <Form.Item initialValue={"All"} name="fit_id">
                        <Select
                          className={"select_Inputs"}
                          showSearch
                          optionFilterProp="children"
                          size="small"
                          onChange={(e) => handleStyle(e)}
                        >
                          <Option value="All">All</Option>
                          {
                            fitChange &&
                              fitChange?.payload?.data.length >= 0 ? (
                              fitChange &&
                              fitChange?.payload?.data.map((it, index) => {
                                return (
                                  <Option
                                    key={index}
                                    value={it.fit_category_id}
                                  >
                                    {it.fit_category_name}
                                  </Option>
                                );
                              })
                            ) : (
                              fitCategory &&
                              fitCategory?.payload?.data.map((item, index) => {
                                return <Option key={item.fit_category_id} value={item.fit_category_id}>{item.fit_category_name}</Option>
                              }
                              )
                            )
                          }
                        </Select>
                      </Form.Item>
                    </div>
                  </div>
                </div>
                {/*Second*/}
                {/* <div className="col-12 col-xl-3 col-md-4 mb-2">
                  <div className=" d-flex flex-row align-items-baseline amazon-product-uploader-input">
                    <label className="labels width44" htmlFor="">G Category</label>
                    <div className="w-100 fit-selectbox-width">
                      <Form.Item initialValue={"All"} name="gender_category_id">
                        <Select
                          className={"select_Inputs"}
                          showSearch
                          optionFilterProp="children"
                          size="small"
                          onChange={(e) => handleStyle(e)}
                        >
                          <Option value="All">All</Option>
                          {
                            genderCategoryChange &&
                              genderCategoryChange?.payload?.data.length >= 0 ? (
                              genderCategoryChange &&
                              genderCategoryChange?.payload?.data.map((it, index) => {
                                return (
                                  <Option
                                    key={index}
                                    value={it.gender_category_id}
                                  >
                                    {it.gender_category_name}
                                  </Option>
                                );
                              })
                            ) : (
                              genderCategory &&
                              genderCategory?.payload?.data.map((it, index) => {
                                return (
                                  <Option
                                    key={index}
                                    value={it.gender_category_id}
                                  >
                                    {it.gender_category_name}
                                  </Option>
                                );
                              })
                            )
                          }
                        </Select>
                      </Form.Item>
                    </div>
                  </div>
                </div> */}
                {/* </div> */}
                <div className="col-12 col-xl-3 col-md-4 mb-2">
                  <div className=" d-flex flex-column align-items-baseline amazon-product-uploader-input">
                    <label className="labels width44" htmlFor="">Style</label>
                    <div className="w-100 fit-selectbox-width">
                      <Form.Item initialValue={"All"} name="style_id">
                        <Select
                          className={"select_Inputs"}
                          showSearch
                          optionFilterProp="children"
                          size="small"
                          onChange={(e) => handleWash(e)}
                        >
                          <Option value="All">All</Option>
                          {
                            styleChange && styleChange?.payload?.data.length >= 0 ? (
                              styleChange && styleChange?.payload?.data.map((style, index) => {
                                return (
                                  <Option key={index} value={style.style_id}>
                                    {style.style_name}
                                  </Option>
                                );
                              })
                            ) : (
                              style && style?.payload?.data.map((style, index) => {
                                return (
                                  <Option key={index} value={style.style_id}>
                                    {style.style_name}
                                  </Option>
                                );
                              })
                            )
                          }
                        </Select>
                      </Form.Item>
                    </div>
                  </div>
                </div>
                <div className="col-12 col-xl-3 col-md-4 mb-2">
                  <div className=" d-flex flex-column align-items-baseline amazon-product-uploader-input">
                    <label className="labels width44" htmlFor="">Wash</label>
                    <div className="w-100 fit-selectbox-width">
                      <Form.Item name="wash_id" initialValue={"All"}>
                        <Select
                          defaultValue={form.getFieldValue().wash_id}
                          className={"select_Inputs"}
                          showSearch
                          optionFilterProp="children"
                          size="small"
                        >
                          <Option value="All">All</Option>
                          {
                            washChange &&
                              washChange?.payload?.data.length >= 0 ? (
                              washChange &&
                              washChange?.payload?.data.map((it, index) => {
                                return (
                                  <Option
                                    key={index}
                                    value={it.wash_id}
                                  >
                                    {it.wash_name}
                                  </Option>
                                );
                              })
                            ) : (
                              wash &&
                              wash?.payload?.data.map((status, index) => {
                                return (
                                  <Option
                                    key={index}
                                    value={status.wash_id}
                                  >
                                    {status.wash_name}
                                  </Option>
                                );
                              }
                              )
                            )
                          }
                        </Select>
                      </Form.Item>
                    </div>
                  </div>
                </div>
                <div className="col-6 mb-2">
                  <div className=" d-flex flex-column align-items-baseline justify-content-end ">
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        marginTop: "3px",
                        float: "right",
                      }}
                    >
                      <Button
                        style={{ width: "fit-content" }}
                        type="primary"
                        htmlType="submit"
                        className="submit-btn-btm m-0 amazon-product-uploader-generate-btn"
                      >
                        Generate
                      </Button>
                    </div>
                  </div>
                </div>
                {/* {
                  selectedRows?.length > 0 ? (
                    <div className="col-6 d-flex justify-content-end align-items-center">
                      <div className="mx-2">Selected {selectedRows.length}{" "}{selectedRows.length === 1 ? "product" : "products"} </div>
                      <Button
                        type="primary"
                        className="submit-btn-btm m-0 amazon-product-uploader-generate-btn"
                        onClick={handleButtonClick}
                        disabled={buttonLoading}
                      >
                        {buttonLoading ? (
                          <Spin size="small" className="customer_payment_ledger_btn_loader mr-1" />
                        ) : (
                          'Download'
                        )}
                      </Button>
                    </div>
                  ) : null
                } */}
              </div>
            </div>
          </div>
        </Form>
      </div>
      <div className="table_content international_order table_content_amazon"
      // style={{ maxWidth: '1600px' }}
      >
        <div>
          
          {amazonProductUploader?.payload?.data !== undefined ?
            (
              data?.length > 0 ? (
                <Table
                  className="bottom-align-th th-general-style td-general-style border prod-table omsTable amazon-product-uploader-table"
                  ref={tableRef}
                  size="small"
                  bordered={false}
                  type="company"
                  dataSource={data && data}
                  columns={columns}
                  scroll={{ x: 'max-content' }}
                  loading={amazonProductUploader?.loading}
                  pagination={{
                    defaultCurrent: 1,
                    defaultPageSize: 100,
                    pageSizeOptions: [100, 500, 1000, 2000, 2500, 3000]
                  }}
                  // rowSelection={{
                  //   ...rowSelection,
                  //   hideSelectAll: true,
                  // }}
                  rowKey="item_id"
                />
              ) : (
                <div className="no-Data">
                  <h1>No Data</h1>
                </div>

              )
            ) : (
              loading && (
                <div className="loader" style={{ marginTop: "20px" }}>
                  <Spin size="medium" />
                </div>
              )
            )
          }
        </div>
      </div>
      <Modal
        title="Confirm Action"
        visible={isModalVisible}
        onOk={handleConfirm}
        onCancel={handleCancel}
        okText="Yes"
        cancelText="No"
        okButtonProps={{ style: { backgroundColor: 'black', borderColor: 'black', color: 'white' } }}
      >
        Are you sure you want to Download
      </Modal>

    </div>
  );
};

export default AmazonProductUploader;
